import React from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useChat } from '../../hooks/useChat';
import Chat from './Chat';
import QuickActions from './QuickActions';
import VoiceInput from './VoiceInput';

export default function EspaceIA() {
  const chat = useChat();

  return (
    <div className="h-full flex flex-col">
      <Header title="Espace IA" />

      <div className="flex-1 overflow-hidden flex flex-col md:pl-64">
        <div className="flex-1 overflow-y-auto px-4 py-4">
          <QuickActions onAction={chat.sendMessage} disabled={chat.isLoading} />
          <Chat {...chat} />
        </div>

        <div className="border-t bg-white">
          <ChatInput
            onSend={chat.sendMessage}
            onVoiceText={chat.sendMessage}
            isLoading={chat.isLoading}
          />
        </div>
      </div>

      <Footer />
    </div>
  );
}

function ChatInput({ onSend, onVoiceText, isLoading }) {
  const [value, setValue] = React.useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (value.trim() && !isLoading) {
      onSend(value);
      setValue('');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="p-4">
      <div className="flex gap-2">
        <input
          type="text"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="Écrivez ou dictez votre message..."
          disabled={isLoading}
          className="flex-1 min-h-[48px] px-4 border border-gray-300 rounded-md focus:ring-ia focus:border-ia disabled:bg-gray-100"
        />
        <VoiceInput onTranscription={onVoiceText} disabled={isLoading} />
        <button
          type="submit"
          disabled={isLoading || !value.trim()}
          className="px-6 min-h-[48px] bg-ia text-white rounded-full hover:bg-ia-dark disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isLoading ? '...' : '➤'}
        </button>
      </div>
    </form>
  );
}
